import React from "react"
import { AppDispatch } from "../../../reduxStore/store"
import {
  ErrorState,
  selectErrorHandler,
  initialState as initialErrorState,
  errorHandlerUpdated,
} from "../errorSlice"
import { useDispatch, useSelector } from "react-redux"
import { Banner } from "../../shared/components/Banner"
import cn from "../../../utils/classes"

interface SuccessBannerProps {
  styleOverrides?: string
}

/**
 * @deprecated Use BannerWithId and bannersWithId state instead. This component uses the legacy successBanner state.
 */
export const SuccessBanner: React.FC<SuccessBannerProps> = ({
  styleOverrides,
}) => {
  const dispatch: AppDispatch = useDispatch()

  const errorState: ErrorState = useSelector(selectErrorHandler)

  const successBannerState = errorState.successBanner

  const handleOnBannerClose = () => {
    const payload: Partial<ErrorState> = {
      successBanner: initialErrorState.successBanner,
    }
    dispatch(errorHandlerUpdated(payload))

    successBannerState.onClose?.()
  }

  return (
    <Banner
      type="success"
      title={successBannerState.title}
      content={successBannerState.content}
      isOpen={successBannerState.isVisible}
      onClose={handleOnBannerClose}
      id="profile-card"
      sticky={true}
      styleOverrides={cn(styleOverrides, "z-10")}
      contentStyleOverrides="text-base"
      titleStyleOverrides="text-base"
    />
  )
}

export default SuccessBanner
